import script from "./fclty-bs-info-chng-rqt.vue?vue&type=script&setup=true&lang=js"
export * from "./fclty-bs-info-chng-rqt.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__